export default __webpack_public_path__ + "static/media/setting-banner.13c918e3.png";